module.exports = __webpack_public_path__ + "img/wave-boy.d924e2a2.png";